import { cn } from "@/utils/cn";

export default function NurseRowGrid({
  nurseId,
  isRowSelected,
  isRowHovered,
  roleGroupBottomBorder,
  children,
}: {
  nurseId: string;
  isRowSelected: boolean;
  isRowHovered: boolean;
  roleGroupBottomBorder: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      data-nurse-id={nurseId}
      className={cn(
        "relative flex w-full min-w-0 items-stretch",
        isRowSelected ? "bg-[#D4F0FF]" : isRowHovered ? "bg-[#e3f5ff]" : "",
        roleGroupBottomBorder && "border-b border-[#D6D6DE]"
      )}
    >
      {children}
    </div>
  );
}
